/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Tab, Tabs } from "@nordcloud/gnui";
import { EventActionAttempt } from "~/generated/graphql";
import { useActionTabNavigation } from "~/hooks";
import { EventEntity } from "~/views/events/types";
import { TabIcon } from "~/views/plans/PlanDetails/Tabs/DetailsTab/components/ActionBox/components/TabIcon";
import { ActionDetails } from "./ActionDetails";
import { GeneralActionSettings } from "./GeneralActionSettings";

type Props = {
  eventEntity: EventEntity;
  planId?: string;
  attempt?: EventActionAttempt;
};

const ACTION_BATCH_TAB_STEP_MAPPING: Record<string, number> = {
  details: 0,
  general: 1,
};

export function ActionBatchSettingsSection({
  eventEntity,
  planId,
  attempt,
}: Props) {
  const { currentStep, handleTab } = useActionTabNavigation(
    ACTION_BATCH_TAB_STEP_MAPPING
  );

  return (
    <>
      <Tabs step={currentStep} handleTab={handleTab}>
        <Tab
          label={
            <span>
              <TabIcon caption="Action Batch Details" icon="eventLog" />
            </span>
          }
          width="auto"
        >
          <ActionDetails
            eventEntity={eventEntity}
            isBatchEntity
            attempt={attempt}
          />
        </Tab>
        <Tab
          label={
            <span>
              <TabIcon
                caption="General Action Batch Settings"
                icon="settings"
              />
            </span>
          }
          width="auto"
        >
          <GeneralActionSettings
            eventEntity={eventEntity}
            planId={planId}
            isBatchEntity
          />
        </Tab>
      </Tabs>
    </>
  );
}
